import { useRouter } from "next/router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import BaseModal from "./BaseModal";
import { Alert, Collapse } from "antd";
import Link from "next/link";

import GuideLabel from "~/components/common/GuideLabel";
import WarningIcon from "~/components/icons/WarningIcon";

import { showAppModal, showAppMessage, setReport } from "~/redux/actions/app";

import { postReport } from "~/redux/actions/user";
import { isMobile } from "react-device-detect";
import { hasAnyRole } from "../../utils/user";
import usePrefs from "~/hooks/usePrefs";

const { Panel } = Collapse;

const NewJobModalV2 = (props) => {
  const router = useRouter();
  const isHrOrAdmin = hasAnyRole(props.user, ["admin", "hr"]);

  const { prefs } = usePrefs();

  const communityPostCost = (prefs.categories_ele_cost || {}).jd || 2;
  const jobApplicationContactViewCont =
    prefs.job_application_contact_view_cost || 20;
  const jobApplicationContactViewFreeQuota =
    prefs.job_application_free_contact_views || 0;

  const Header = ({ className }) => (
    <div className={`text-center header ${className}`}>
      {isMobile && <div className="font-32  modal-title">发布招聘</div>}
      {isMobile ? (
        <div className="tip">
          请根据您所要招聘的职位类型以及预算选择对应的招聘方式：）
        </div>
      ) : (
        <Alert
          message="请根据您所要招聘的职位类型以及预算选择对应的招聘方式：）"
          type="warning"
        />
      )}
    </div>
  );
  const list1 = (
    <div className="content-container">
      <div className="top-container">
        <div className="category-image">
          <img src="/static/icons/new-job-community.png" />
        </div>
        <div className="description">
          <div className="title">社区快速发帖 · 自行沟通对接</div>
          <div className="content bullet-points">
            <div>
              无需审核，只需 {communityPostCost} 电量，即可在社区广场发布招聘
            </div>
            <div>帖子需写明项目介绍、薪资报酬、结算方式等必要信息</div>
            <div>申请者自行申请，招聘方自行筛选，社区不干涉不保障</div>
            <div>如需增加曝光和阅读，可申请“付费置顶”，价格很友好</div>
          </div>
        </div>
      </div>
      <div className="bottom-container">
        <div className="feature-list">
          <div className="feature-item">
            <img
              className="feature-image"
              src="/static/icons/new-job-community-feature-1.png"
            />
            <span className="feature-text">发布简单</span>
          </div>
          <div className="feature-item">
            <img
              className="feature-image"
              src="/static/icons/new-job-community-feature-2.png"
            />
            <span className="feature-text">极低门槛</span>
          </div>
          <div className="feature-item">
            <img
              className="feature-image"
              src="/static/icons/new-job-community-feature-3.png"
            />
            <span className="feature-text">评论互动</span>
          </div>
        </div>
        <div
          className="btn"
          onClick={() => router.push("/jobs/new?c=jd")}
        >
          发布至社区广场
        </div>
        <div className="post-rules">
          <div className="rule">
            <WarningIcon className="warning-icon" />
            <Link
              className="rule-link"
              href="https://eleduck.com/posts/6GzfGe"
              target="_blank"
            >
              查看社区规则
            </Link>
          </div>
        </div>
      </div>
    </div>
  );

  const list2 = (
    <div className="content-container">
      <div className="top-container">
        <div className="category-image">
          <img src="/static/icons/new-job-jobs-channel.png" />
        </div>
        <div className="description">
          <div className="title">自动匹配简历 · 电量查看人选</div>
          <div className="content bullet-points">
            <div>按照招聘模板撰写 JD，职位月薪不低于 10,000 元</div>
            <div>免费提交，专人审核，发布后会同步推送至人才库</div>
            <div>
              人才库智能匹配、精准推荐简历，{jobApplicationContactViewCont}{" "}
              电量/完整简历
            </div>
            {jobApplicationContactViewFreeQuota > 0 && (
              <div>
                <span className="new-user-benefit">新用户福利：</span>
                可免电量获取 {jobApplicationContactViewFreeQuota}{" "}
                份候选人完整简历
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="bottom-container">
        <div className="feature-list">
          <div className="feature-item">
            <img
              className="feature-image"
              src="/static/icons/new-job-jobs-channel-feature-1.png"
            />
            <span className="feature-text">免费发布</span>
          </div>
          <div className="feature-item">
            <img
              className="feature-image"
              src="/static/icons/new-job-jobs-channel-feature-2.png"
            />
            <span className="feature-text">智能匹配</span>
          </div>
          <div className="feature-item">
            <img
              className="feature-image"
              src="/static/icons/new-job-jobs-channel-feature-3.png"
            />
            <span className="feature-text">简历保障</span>
          </div>
        </div>
        <div
          className="btn"
          onClick={() => router.push("/jobs/new?c=jobs_channel")}
        >
          提交至职位频道
        </div>
        <div className="post-rules">
          {/* 暂时隐藏视频介绍 */}
          {/* <div className="rule">
            <WarningIcon className="warning-icon" />
            <Link
              className="rule-link"
              href="https://eleduck.com/posts/6GzfGe"
              target="_blank"
            >
              播放视频介绍
            </Link>
          </div> */}
          <div className="rule">
            <WarningIcon className="warning-icon" />
            <Link
              className="rule-link"
              href="https://eleduck.com/posts/1nfKjE"
              target="_blank"
            >
              查看发布规则
            </Link>
          </div>
        </div>
      </div>
    </div>
  );

  const list3 = (
    <div className="content-container">
      <div className="top-container">
        <div className="category-image">
          <img src="/static/icons/new-job-talent.png" />
        </div>
        <div className="description">
          <div className="title">专业 HR 1v1 服务 · 精准推荐人才</div>
          <div className="content bullet-points">
            <div>月薪 {">"} 15,000 元的职位可享社区 HR 专属人工服务</div>
            <div>JD 优化/背景确认/简历精选/面试沟通等全流程服务</div>
            <div>3-5 个工作日即可快速、精准找到候选人，省时省心</div>
            <div>推荐入职成功后，仅需后付该职位月薪的 30-50%</div>
          </div>
        </div>
      </div>
      <div className="bottom-container">
        <div className="feature-list">
          <div className="feature-item">
            <img
              className="feature-image"
              src="/static/icons/new-job-talent-feature-1.png"
            />
            <span className="feature-text">专属服务</span>
          </div>
          <div className="feature-item">
            <img
              className="feature-image"
              src="/static/icons/new-job-talent-feature-2.png"
            />
            <span className="feature-text">人才保障</span>
          </div>
          <div className="feature-item">
            <img
              className="feature-image"
              src="/static/icons/new-job-talent-feature-3.png"
            />
            <span className="feature-text">价格友好</span>
          </div>
        </div>
        <div
          className="btn"
          onClick={() => {
            if (isHrOrAdmin) {
              router.push("/jobs/new?c=talent");
            } else {
              window.open("https://eleduck.com/posts/z1f0Kp");
            }
          }}
        >
          申请专人服务
        </div>
        <div className="post-rules">
          <div className="rule">
            <WarningIcon className="warning-icon" />
            <Link
              className="rule-link"
              href="https://eleduck.com/posts/z1f0Kp"
              target="_blank"
            >
              查看服务细则
            </Link>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <BaseModal
      className="newjob-modal-v2"
      noClose
      isOpen={props.isOpen}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      hideModal={props.hideModal}
      showLogo={false}
      header={isMobile && <Header class="show-on-mobile" />}
    >
      <div className="newjob-body">
        <div className="item item1">
          <Collapse
            className="show-on-mobile"
            bordered={false}
          >
            <Panel
              showArrow={false}
              header={
                <>
                  <div className="title-w">
                    <div className="title">
                      兼职零活发布
                      <GuideLabel
                        text="简单"
                        color="#FFAA49"
                        className="feature-label"
                      />
                    </div>
                    <div className="arrow"></div>
                  </div>
                  <div className="sub-title">
                    适用于外包零活/短期兼职等工作的招聘
                  </div>
                </>
              }
            >
              {list1}
            </Panel>
          </Collapse>
          <div className="show-on-pc">
            <div className="header">
              <div className="title">
                兼职零活发布
                <GuideLabel
                  text="简单"
                  color="#FFAA49"
                  className="feature-label"
                />
              </div>
              <div className="sub-title">
                适用于外包零活/短期兼职等工作的招聘
              </div>
            </div>
            {list1}
          </div>
        </div>
        <div className="separator"></div>
        <div className="item item2">
          <Collapse
            className="show-on-mobile"
            bordered={false}
          >
            <Panel
              showArrow={false}
              header={
                <>
                  <div className="title-w">
                    <div className="title">
                      简历快速匹配
                      <GuideLabel
                        text="快速"
                        className="feature-label"
                      />
                    </div>
                    <div className="arrow"></div>
                  </div>
                  <div className="sub-title">适用于长期稳定的全职岗位招聘</div>
                </>
              }
            >
              {list2}
            </Panel>
          </Collapse>
          <div className="show-on-pc">
            <div className="header">
              <div className="title">
                简历快速匹配
                <GuideLabel
                  text="快速"
                  className="feature-label"
                />
              </div>
              <div className="sub-title">适用于长期稳定的全职岗位招聘</div>
            </div>
            {list2}
          </div>
        </div>
        <div className="separator"></div>
        <div className="item item3">
          <Collapse
            className="show-on-mobile"
            bordered={false}
          >
            <Panel
              showArrow={false}
              header={
                <>
                  <div className="title-w">
                    <div className="title">
                      精准人才推荐
                      <GuideLabel
                        text="精准"
                        color="#EE696B"
                        className="feature-label"
                      />
                    </div>
                    <div className="arrow"></div>
                  </div>
                  <div className="sub-title">
                    适用于远程/高端人才的快速精准招聘
                  </div>
                </>
              }
            >
              {list3}
            </Panel>
          </Collapse>
          <div className="show-on-pc">
            <div className="header">
              <div className="title">
                精准人才推荐
                <GuideLabel
                  text="精准"
                  color="#EE696B"
                  className="feature-label"
                />
              </div>
              <div className="sub-title">适用于远程/高端人才的快速精准招聘</div>
            </div>
            {list3}
          </div>
        </div>
      </div>
    </BaseModal>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  token: state.user.token,
  report: state.app.report,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showAppModal,
      showAppMessage,
      setReport,
      postReport,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(NewJobModalV2);
